import type { Construction } from "@/adapters/api";

export interface Obra {
	id: string;
	slug?: string;
	canteiroId: string;
	name: string;
	status: string;
	description?: string;
	startDate?: string;
	expectedEndDate?: string;
	coverImageUrl?: string;
	technicalManager?: string;
}

export function toObra(c: Construction): Obra {
	return {
		id: c.id,
		canteiroId: c.worksite_id,
		name: c.name,
		status: c.status,
		description: c.description || undefined,
		startDate: c.start_date,
		expectedEndDate: c.expected_end_date,
		coverImageUrl: c.cover_image_url || undefined,
		technicalManager: c.technical_manager || undefined,
	};
}

export function obraUrlKey(obra: Obra): string {
	return obra.slug ?? obra.id;
}

export function resolveObra(
	obras: Obra[],
	value: string | null | undefined,
): Obra | undefined {
	if (!value) return undefined;
	return obras.find((o) => o.id === value || o.slug === value);
}

export function obraSwitchPath(
	obra: Obra,
	location: { pathname: string; search: string },
): string {
	const section = location.pathname.split("/")[2] ?? "";
	const qs = new URLSearchParams(location.search).toString();
	return `/${obraUrlKey(obra)}${section ? `/${section}` : ""}${qs ? `?${qs}` : ""}`;
}

export function countObrasByCanteiro(obras: Obra[]): Map<string, number> {
	const counts = new Map<string, number>();
	for (const obra of obras) {
		counts.set(obra.canteiroId, (counts.get(obra.canteiroId) ?? 0) + 1);
	}
	return counts;
}
